import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import "./style.css";
import {
  getSelfBaseUrl,
  isNetworkRequestFailedError,
  splitUrl,
} from "../../config/helpers";
import keys from "../../config/keys";
import historyAction from "../../redux/history/action";
import PageHead from "../../component/pageHead/PageHead";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";
import api from "../../config/api";
import onboardingAction from "../../redux/onboarding/action";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import moment from "moment";
import base64 from "base-64";
import authAction from "../../redux/auth/action";

class Contribution extends Component {
  state = {
    amount: "",
    rsaPin: "",
    phoneNumber: "",
    transactionDate: moment().format("YYYY-MMMM-DD"),
    disableBtn: false,
  };

  async componentDidMount() {
    const { history, setHistory, user, getUser, validateUser } = this.props;

    setHistory(history);

    // this.setState({
    //   rsaPin: user.User.rsaPin,
    //   mobileNumber: user.User.mobileNumber
    // });

    if (!validateUser.userName && user) {
      this.setState({ isLoading: true });
      try {
        const response = await api.getUsernameAndPassword(
          { userName: user.User.userName },
          user.token
        );
        const data = {
          userName: response.data.result.UserName,
          password: response.data.result.Password,
        };
        getUser(data);
      } catch (e) {
        console.log("Error", e.message);
      }
      this.setState({ isLoading: false });
    }
  }

  generateTransactionReference = async () => {
    const { user, validateUser, setAlertMessage } = this.props;
    const rsaPin = user.User.rsaPin;

    try {
      this.setState({ isLoading: true });

      const header = {
        Authorization:
          "Basic " +
          base64.encode(validateUser.userName + ":" + validateUser.password),
      };

      const response = await api.validation({ rsaPin }, header);

      console.log("response =>", response);

      this.setState({
        phoneNumber: response.phoneNumber,
        transactionRef: response.transactionRef,
        firstName: response.firstName,
        lastName: response.lastName,
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.generateTransactionReference
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  mppContributionCallback = async ({ queryStrings }, transactionDate) => {
    const { user, setAlertMessage } = this.props;
    const rsaPin = user.User.rsaPin;

    try {
      this.setState({ isLoading: true });

      const payload = {
        id: queryStrings.id,
        pin: rsaPin,
        amount: this.state.amount,
        refNo: queryStrings.refrence,
        transactionDate: transactionDate,
        tsDate: new Date().toISOString(),
        paymentStatus: "success",
      };

      const response = await api.MPPContributionCallback(payload);
      console.log("response =>", response);
      setAlertMessage({
        type: "success",
        message: `Transaction id is ${queryStrings.id}`,
        secondMessage: `Reference is ${queryStrings.refrence}`,
      });
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () =>
              this.mppContributionCallback({ queryStrings }, transactionDate)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  submit = async () => {
    const { user, setAlertMessage } = this.props;
    const rsaPin = user.User.rsaPin;

    const { amount, phoneNumber, transactionRef, firstName, lastName } =
      this.state;

    try {
      this.setState({ isLoading: true });

      const body = {
        MerchantRef: transactionRef,
        Amount: Number(amount) * 100,
        contributorId: rsaPin,
        CustomerName: firstName + " " + lastName,
        CustomerEmail: user.User.Email,
        CustomerMobile: phoneNumber,
        IntegrationKey: keys.CYBERPAY.INTEGRATION_KEY,
        Description: keys.CYBERPAY.NARRATION,
        ReturnUrl: `${getSelfBaseUrl()}/cyberpay-success`,
        Currency: "NGN",
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Credentials: keys.CYBERPAY.CREDENTIALS,
          PfaCode: keys.CYBERPAY.PFA_CODE,
        },
        body: JSON.stringify(body),
      };

      const response = await fetch(
        "https://payment-api.cyberpay.ng/api/v1/payments",
        options
      );

      const json = await response.json();

      if (!json.succeeded) {
        throw new Error(json.message);
      }

      const popupWindow = {
        width: 500,
        height: window.innerHeight,
        left: (window.innerWidth - window.innerWidth / 2) / 2,
      };

      const newWin = window.open(
        json.data.redirectUrl,
        "cyperspace-payment",
        `height=${popupWindow.height},width=${popupWindow.width},left=${popupWindow.left}`
      );

      console.log("newWin =>", newWin);

      const transactionDate = new Date().toISOString();

      const int = setInterval(() => {
        try {
          if (newWin) {
            const url = newWin.location.href;
            const filteredUrl = splitUrl(url);

            console.log("url =>", url);

            if (filteredUrl.path === "/cyberpay-success") {
              clearInterval(int);
              newWin.close();
              this.mppContributionCallback(filteredUrl, transactionDate);
            }
          }
        } catch (e) {
          console.log("E =>", e);
        }
      }, 1000);

      this.setState({
        disableBtn: true,
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.submit : null,
      });
    }

    this.setState({
      transactionRef: "",
      phoneNumber: "",
      amount: "",
      isLoading: false,
    });
  };

  render() {
    const { amount, transactionDate, isLoading, phoneNumber, transactionRef } =
      this.state;
    const { user } = this.props;

    if (!user) return <div />;

    const { rsaPin } = user.User;

    return (
      <Container>
        {isLoading && <CustomLoader text="Please wait" />}
        <PageHead title="CONTRIBUTION" containerStyles={{ width: "100%" }} />
        <InputComp
          type="text"
          name="rsaPin"
          value={rsaPin}
          placeholder="RSA PIN"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ rsaPin: e.target.value });
          }}
          disabled
        />
        <InputComp
          type="text"
          name="mobileNum"
          value={phoneNumber}
          placeholder="Mobile Number"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ mobileNumber: e.target.value });
          }}
          disabled
        />
        <InputComp
          type="text"
          name="transactionDate"
          value={transactionDate}
          placeholder="Transaction Date"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ transactionDate: e.target.value });
          }}
          disabled
        />
        <InputComp
          type="text"
          name="transactionRef"
          value={transactionRef}
          placeholder="Transaction Reference"
          containerStyles={{ width: "100%" }}
          disabled
        />

        <Row className="my-2 justify-content-center">
          <Col className="p-0" sm={6} md={6}>
            <CustomButton
              buttonText="Generate Transaction Reference"
              buttonClasses="btn-block"
              onClick={this.generateTransactionReference}
            />
          </Col>
        </Row>
        <InputComp
          type="text"
          name="amount"
          value={amount}
          placeholder="Amount"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            this.setState({ amount: e.target.value });
          }}
        />
        <Row className="my-2 justify-content-center">
          <Col className="p-0" sm={5} md={3}>
            <CustomButton
              buttonText="Submit"
              buttonClasses="btn-block"
              onClick={this.submit}
              // disabled={true}
            />
          </Col>
        </Row>
        <p className="contribution-instruction-text">
          *Please make sure that your browser allow popup windows
        </p>
        <p className="contribution-instruction-text">
          *The payment is subject to terms and condition for card payments
        </p>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  validateUser: state.onboarding.user,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  getUser: onboardingAction.getUser,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Contribution);
